import React, { PropsWithChildren } from "react";

import { useAuth0 } from "@auth0/auth0-react";
import { Provider } from "react-redux";
import { store } from "../reducers";

const ReduxProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { isLoading } = useAuth0();

  if (isLoading) {
    return null;
  }

  return <Provider store={store}>{children}</Provider>;
};

export default ReduxProvider;
